import { PlanogramUI } from '../../context/PlanogramAutomation';

export const hasDataStockTurnover = (planogram: PlanogramUI) => {
    const hasTurnover =
        typeof planogram.daily_stock_turnover === 'number' &&
        planogram.daily_stock_turnover > 0;
    return hasTurnover;
};

export const hasDataToCalculateMargin = (planogram: PlanogramUI) => {
    const hasPrice =
        typeof planogram.price_final_in_cents === 'number' &&
        planogram.price_final_in_cents > 0;

    const hasCost =
        typeof planogram.product?.last_price_in_cents === 'number' &&
        planogram.product.last_price_in_cents > 0;

    return hasPrice && hasCost;
};

export const hasDataToCalculatePrice = (planogram: PlanogramUI) => {
    const hasCost =
        typeof planogram.product?.last_price_in_cents === 'number' &&
        planogram.product.last_price_in_cents > 0;

    const hasExpectedMargin =
        typeof planogram.expected_gross_margin === 'number' &&
        planogram.expected_gross_margin > 0 &&
        planogram.expected_gross_margin < 1;

    return hasCost && hasExpectedMargin;
};
